import React, { useEffect, useRef, useState } from "react";
import styles from "./who-we-are.module.css";
import teamPhoto from "../../assets/gridimages/who-we-are-hackutd.jpg";
import Skeleton from "../../shared/skeleton";
import skeletonStyles from "../../shared/skeleton.module.css";

const highlights = [
  "Peer tutoring",
  "Technical societies",
  "Industry networking",
  "Events all semester",
];

const WhoWeAre = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [revealed, setRevealed] = useState(false);
  const [photoLoaded, setPhotoLoaded] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0.18 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`${styles.whoWeAre} ${revealed ? styles.revealed : ""}`}
      id="who-we-are"
      ref={sectionRef}
    >
      <div className={styles.photoBleed}>
        {!photoLoaded && <Skeleton />}
        <img
          src={teamPhoto}
          alt="IEEE UTD members at the IEEE table at HackUTD"
          className={`${skeletonStyles.fadeImg} ${photoLoaded ? skeletonStyles.loaded : ""}`}
          onLoad={() => setPhotoLoaded(true)}
          onError={() => setPhotoLoaded(true)}
        />
      </div>
      <div className={styles.container}>
        <div className={styles.layout}>
          <div className={styles.copy}>
            <p className={styles.eyebrow}>About the branch</p>
            <h2 className={styles.title}>Who we are</h2>
            <p className={styles.description}>
              IEEE UTD is one of the largest technical professional societies
              in the region. Students come here to learn with peers, meet
              people in the field, and take part in events all semester.
            </p>
            <ul className={styles.highlights}>
              {highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <a href="/about" className={styles.learnMoreButton}>
              <span className={styles.learnMoreText}>Learn more about us</span>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
